import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { Settings } from '../models/common.model';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { Title } from '@angular/platform-browser';
// import { firstValueFrom } from 'rxjs';
// import { Router } from '@angular/router';
import { MessagingService } from './messaging.service';
import { RuntimeConfigService } from './runtimeConfig.service';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  script = document.createElement('script');
  api: any;
  projectSettings: any;

  // multitenant to single tenant
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private commonService: CommonService,
    private titleService: Title,
    private config: RuntimeConfigService,
    @Inject(PLATFORM_ID) private platformId: object,
    private _messagingService: MessagingService
  ) { }

  async setUpGoogleScript(): Promise<void> {
    const apiKey = this.config.googleApiKey;
    setTimeout(() => {
      const head = document.getElementsByTagName('body')[0];
      if (!document.getElementById('testScriptName')) {
        this.script.type = 'text/javascript';
        this.script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,drawing,geometry,visualization&language=en`;
        this.script.id = 'newTestScriptName';
        this.script.async = true;
        head.appendChild(this.script);
      }
    }, 100);
  }

  async load(): Promise<void> {
    // multitenant to single tenant
    // const res = await this.verifyTenantUrl();
    // if (!res || !res.isVerfied) {
    //   this.router.navigate(['noTenant']);
    // } else {
    //   const token = localStorage.getItem(environment.storageKey);
    //   if (!token) {
    //     if (this.router.url !== '/auth/login') {
    //       this.router.navigate(['auth/login'], {
    //         queryParams: { verified: res.isVerfied,
    //           subscriptionStatus: res.status }
    //       });
    //     }
    //     if (res.isVerfied) {
    //       this.router.navigate(['auth/login'], {
    //         queryParams: { verified: res.isVerfied,
    //           subscriptionStatus: res.status }
    //       });
    //     }
    //   }
    // this.setData();
    this.api = `${environment.base_url}admin/settings`;
    await this.getGreatSettings();
    await this.getGreatSettings();
    this._messagingService.requestPermission();
    this._messagingService.listenForFrontMessages();
    // }
  }

  // multitenant to single tenant
  // async verifyTenantUrl(): Promise<any> {
  //   console.log('Verifying tenant URL... by sudhir', environment);
  //   const verifyUrl = `${environment.slugVerifyUrl}admin/tenant/verifyUrl`;
  //   const body = { url: window.location.origin };
  //   try {
  //     const response: any = await firstValueFrom(
  //       this.http.post(verifyUrl, body)
  //     );
  //     return response?.data;
  //   } catch (error) {
  //     console.error('Error verifying tenant URL:', error);
  //     return null;
  //   }
  // }

  async getGreatSettings(): Promise<void> {
    const res = await this.http.get<{ data: Settings }>(this.api).toPromise();
    if (res?.data) {
      this.commonService.settingsSubject.next(res.data);
      this.projectSettings = res.data;
      this.setData();
    }
  }

  setData(): void {
    if (this.projectSettings) {
      localStorage.setItem('webSettings', JSON.stringify(this.projectSettings));
    }

    // multitenant to single tenant
    // setTimeout(() => {
    //   if (this.projectSettings && this.projectSettings.colorCodes) {
    //     document.documentElement.style.setProperty(
    //       '--c_primary',
    //       this.projectSettings.colorCodes
    //     );
    //   }

    //   if (this.projectSettings?.buttonPrimary) {
    //     document.documentElement.style.setProperty(
    //       '--c_secondary',
    //       this.projectSettings.buttonPrimary
    //     );
    //   }

    //   if (this.projectSettings?.theme) {
    //     document.documentElement.style.setProperty(
    //       '--c_primary',
    //       this.projectSettings.theme
    //     );
    //   }

    //   if (this.projectSettings?.buttonTextColor) {
    //     document.documentElement.style.setProperty(
    //       '--c_secondary_txt',
    //       this.projectSettings.buttonTextColor
    //     );
    //   }

    //   if (this.projectSettings?.favIcon) {
    //     const faviconElement = this._document.getElementById('appFavicon');
    //     if (faviconElement) {
    //       faviconElement.setAttribute('href', this.projectSettings.favIcon);
    //     }
    //   }

    //   if (this.projectSettings?.appName) {
    //     this.titleService.setTitle(`${this.projectSettings.appName}`);
    //   }

    //   if (this.projectSettings?.appLogo) {
    //     const appLogoElement = this._document.getElementById('appLogo');
    //     if (appLogoElement) {
    //       appLogoElement.setAttribute('src', this.projectSettings.appLogo);
    //     }
    //   }

    //   if (this.projectSettings?.webLogo) {
    //     const webLogoElement = this._document.getElementById('webLogo');
    //     if (webLogoElement) {
    //       webLogoElement.setAttribute('src', this.projectSettings.webLogo);
    //     }
    //   }
    // }, 1000);
  }
}
